module.exports = __webpack_public_path__ + "static/media/medical.d848b084.png";